import React, { useContext, useEffect, useState } from 'react'

import { DefaultContent } from '../../components/common/DefaultContent'

import { BellRinging, Siren, WarningDiamond } from '@phosphor-icons/react'

import { Container, Content, Filter, Header, InputContainer } from './styled'

import { ActionCard } from '../../components/ActionCard'
import { DateRangePickerComp } from '../../components/DateRangePicker'
import { Modal } from '../../components/Modal'
import { SideTab } from '../../components/SideTab'
import { Button } from '../../components/common/Button'
import { Select } from '../../components/common/Select'
import { AlwaysAlertSideTab } from './components/AlwaysAlertSideTab'
import { AlwaysAlertTable } from './components/AlwaysAlertTable'
import { Details } from './components/Details'
import { Status } from './components/Status'
import { Warnings } from './components/Warnings'

import { addDays } from 'date-fns'
import api from '../../services/api'

import { Helmet } from 'react-helmet'
import { AlwaysAlertContext } from '../../context/context_alwaysAlert'
import useFilteredData from '../../hooks/searchHook'
import { useNavigate, useNavigation } from 'react-router-dom'

interface Idate {
  startDate: Date
  endDate: Date
  key: string
}
interface IBase {
  id: string
  value: string
}

export const AlwaysAlert = () => {
  const { baseList, baseOptions } = useContext(AlwaysAlertContext)

  console.log('🚀 ~ file: index.tsx:39 ~ AlwaysAlert ~ baseList:', baseList)
  const [alwaysAlertSideTab, setAlwaysAlertSideTab] = useState<boolean>(false)

  const [statusSideTab, setStatusSideTab] = useState<boolean>(false)
  const [alertStatusData, setAlertStatusData] = useState()
  const [sendedAlert, setSendedAlert] = useState(false)

  const [noticeSideTab, setNoticeSideTab] = useState<boolean>(false)

  const [unansweredMessages, setUnansweredMessages] = useState([])
  const [unansweredMessagesModal, setUnansweredMessagesModal] = useState(false)
  const [unblockUser, setUnblockUser] = useState(false)
  const [unblockUserConfirm, setUnblockUserConfirm] = useState(false)
  const [unblockReason, setUnblockReason] = useState('')
  const [confirmSendAlert, setConfirmSendAlert] = useState(false)

  const [base, setBase] = useState<string>()
  const [startHour, setStartHour] = useState<string>()
  const [endHour, setEndHour] = useState<string>()

  const [markAsRead, setMarkAsRead] = useState<boolean>(false)
  const [details, setDetails] = useState<boolean>(false)
  const [detailsData, setDetailsData] = useState({
    id: '',
    name: '',
    phone: '',
    email: '',
    role: '',
    outpost: '',
    base: '',
    sent_at: '',
    code: '',
    online: false,
  })

  const [dateRangeData, setDateRangeData] = useState<Idate[]>([
    {
      startDate: new Date(),
      endDate: addDays(new Date(), 7),
      key: 'selection',
    },
  ])

  const navigate = useNavigate()
  const [data, setUsers] = useState<[]>([])
  const { filteredData } = useFilteredData(data)

  const hours = Array.from({ length: 48 }, (_, index) => {
    const totalMinutes = index * 30
    const hours = Math.floor(totalMinutes / 60)
    const minutes = totalMinutes % 60
    const id = `${hours.toString().padStart(2, '0')}:${minutes
      .toString()
      .padStart(2, '0')}`
    return {
      id,
      value: `${hours.toString().padStart(2, '0')}:${minutes
        .toString()
        .padStart(2, '0')}`,
    }
  })

  const [filters, setFilters] = useState({
    start_date: dateRangeData[0].startDate,
    end_date: dateRangeData[0].endDate,
  })

  const handleUnblockUser = () => {
    console.log(alertStatusData)
    api
      .post('/v1/dashboard/employees/unblock', {
        id: alertStatusData?.AlwaysAlertMessages[0]?.Employee.User
          ?.BlockedUsers[0].id,
        id_user: alertStatusData?.id_user,
        blocked_reason: unblockReason,
      })
      .then((response) => {
        console.log(response)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleAlertStatus = (id: string, userId: string) => {
    const alertMessage = data.filter(
      // eslint-disable-next-line camelcase
      (el) => el.id === id && el.id_user === userId,
    )
    setAlertStatusData(alertMessage[0])
    setStatusSideTab(true)
  }

  const handleSubmit = (e) => {
    e.preventDefault()
    try {
      console.log({
        start_date: dateRangeData[0].startDate,
        end_date: dateRangeData[0].endDate,
        base,
        start_hour: startHour,
        end_hour: endHour,
      })
      api
        .post('/v1/dashboard/surveillance/always-alert', {
          start_date: dateRangeData[0].startDate,
          end_date: dateRangeData[0].endDate,
          base,
          start_hour: startHour,
          end_hour: endHour,
        })
        .then((response) => {
          console.log(response.data)
          setUsers(response.data)
        })
        .catch((error) => {
          console.log(error)
        })
    } catch (err) {
      console.log(err, 'error')
    }
  }

  const handleMarkAsRead = (id: string[]) => {
    if (id[0] === 'all') {
      id = unansweredMessages.map((el) => el.id)
    }

    api
      .post('/v1/always-alert/read', {
        id,
      })
      .then(() => {
        getUnansweredMessages(false)
        setDetails(false)
        setMarkAsRead(true)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  const handleSetDetails = (id: string) => {
    const alwaysAlertMessage = unansweredMessages.filter((el) => el.id === id)

    if (alwaysAlertMessage.length > 0) {
      const message = alwaysAlertMessage[0]
      setDetailsData({
        id: message.id,
        name: message.Employee.User.UserInfo[0].name,
        phone: message.Employee.User.UserInfo[0].phone,
        email: message.Employee.User.UserInfo[0].email,
        role: message.Employee.User.role,
        base: message.Employee.Base.base,
        outpost: message.Employee.Base.outpost,
        sent_at: new Date(message.sent_at).toLocaleString(),
        code: message.code,
        online: message.Employee.User.SocketConnections.length > 0,
      })
      setDetails(true)
    }
  }

  const getUnansweredMessages = (showModal: boolean) => {
    api
      .post('/v1/always-alert/list-unanswered')
      .then((response) => {
        console.log(response.data)
        setUnansweredMessages(response.data)
        if (response.data.length > 0) setUnansweredMessagesModal(showModal)
      })
      .catch((error) => {
        console.log(error)
      })
  }

  useEffect(() => {
    getUnansweredMessages(true)

    const getUnansweredMessagesInterval = setInterval(() => {
      getUnansweredMessages(false)
    }, 10000)

    return () => {
      clearInterval(getUnansweredMessagesInterval)
    }
  }, [])

  return (
    <>
      <Helmet>
        <title>Previx - Sempre alerta</title>
        <meta
          name="Previx - Sempre alerta"
          content="Página de envios sempre alerta"
        />
      </Helmet>
      <DefaultContent
        title="Previx - Vigilância - Sempre alerta"
        icon={<BellRinging size={36} color="#003E5F" weight="bold" />}
      >
        <Header>
          <ActionCard.Root>
            <ActionCard.Content
              onclick={() => setAlwaysAlertSideTab((prev) => !prev)}
              background="#770A00"
              border="#9A0A02"
              color="#fff"
            >
              <ActionCard.Icon
                transform={20}
                icon={<Siren size={60} weight="fill" color="#FFEEE7" />}
              />

              <ActionCard.Information value="Sempre alerta" />
            </ActionCard.Content>
          </ActionCard.Root>
          <ActionCard.Root>
            <ActionCard.Content
              onclick={() => setNoticeSideTab((prev) => !prev)}
              background="#770A00"
              border="#9A0A02"
              color="#fff"
            >
              <ActionCard.Icon
                icon={
                  <WarningDiamond size={60} weight="fill" color="#FFEEE7" />
                }
              />

              <ActionCard.Information value="Avisos do sempre alerta" />
              <ActionCard.Notification value={unansweredMessages.length} />
            </ActionCard.Content>
          </ActionCard.Root>
        </Header>
        <Container onSubmit={handleSubmit}>
          <Filter>
            <span>Filtros de busca:</span>
            <InputContainer>
              <DateRangePickerComp
                dateRange={dateRangeData}
                setDateRange={setDateRangeData}
              />
            </InputContainer>
            <InputContainer>
              <Select
                onchange={(e) => setBase(e.target.value)}
                label={{
                  title: 'Base',
                  htmlFor: '',
                  color: '',
                  fontSize: '14px',
                }}
                data={baseOptions}
                backgroundcolor=""
                bordercolor=""
                currentOption={filters.base}
                outlinecolor=""
              />
            </InputContainer>
            <InputContainer>
              <Select
                onchange={(e) => setStartHour(e.target.value)}
                label={{
                  title: 'Hora de início',
                  htmlFor: '',
                  color: '',
                  fontSize: '14px',
                }}
                data={hours}
                backgroundcolor=""
                bordercolor=""
                currentOption={filters.start_hour}
                outlinecolor=""
              />
            </InputContainer>
            <InputContainer>
              <Select
                onchange={(e) => setEndHour(e.target.value)}
                label={{
                  title: 'Hora de fim',
                  htmlFor: '',
                  color: '',
                  fontSize: '14px',
                }}
                // data={access}
                data={hours}
                backgroundcolor=""
                bordercolor=""
                currentOption={filters.end}
                outlinecolor=""
              />
            </InputContainer>
            <InputContainer
              style={{ marginBottom: '0.2rem', alignSelf: 'flex-end' }}
            >
              <Button.Root
                backgroundColor="#00517D"
                type="submit"
                padding=".6rem"
              >
                <Button.Content title="Buscar" color="#fff" />
              </Button.Root>
            </InputContainer>
          </Filter>
          <Content>
            <AlwaysAlertTable
              onclick={handleAlertStatus}
              data={filteredData}
              base={baseOptions}
            />
          </Content>
        </Container>
      </DefaultContent>

      <SideTab
        open={alwaysAlertSideTab}
        width="50%"
        title="Sempre alerta"
        toggleFunction={() => setAlwaysAlertSideTab((prev) => !prev)}
      >
        <AlwaysAlertSideTab
          onclick={() => setConfirmSendAlert((prev) => !prev)}
        />
      </SideTab>

      <SideTab
        title="Status do usuário"
        open={statusSideTab}
        toggleFunction={() => setStatusSideTab((prev) => !prev)}
      >
        <Status
          data={alertStatusData}
          setUnblockModal={setUnblockUser}
          unblockReason={unblockReason}
          setUnblockReason={setUnblockReason}
        />
      </SideTab>

      <SideTab
        open={noticeSideTab}
        title="Avisos do sempre alerta"
        width="fit-content"
        toggleFunction={() => setNoticeSideTab((prev) => !prev)}
      >
        <Warnings
          markOnClick={handleMarkAsRead}
          viewOnClick={handleSetDetails}
          data={unansweredMessages}
        />
      </SideTab>

      <SideTab
        open={details}
        title="Detalhado de um usuário"
        width="45%"
        toggleFunction={() => setDetails((prev) => !prev)}
      >
        <Details onclick={handleMarkAsRead} data={detailsData} />
      </SideTab>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="fit-content"
        height="fit-content"
        left="50%"
        top="50%"
        open={confirmSendAlert}
        setIsOpenController={() => setConfirmSendAlert((prev) => !prev)}
      >
        <Modal.Header onclick={() => setConfirmSendAlert((prev) => !prev)} />
        <Modal.Content
          value="Você deseja realmente enviar o alerta?"
          subvalue="Ao clicar em enviar, o alerta será encaminhado para todos os seguranças."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => setConfirmSendAlert((prev) => !prev)}
          >
            <Button.Content title="Não, cancelar" color="#770A00" />
          </Button.Root>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => setSendedAlert((prev) => !prev)}
          >
            <Button.Content title="Enviar" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        height="fit-content"
        width="25%"
        left="50%"
        top="50%"
        open={sendedAlert}
        setIsOpenController={() => setSendedAlert((prev) => !prev)}
      >
        <Modal.Header onclick={() => setSendedAlert((prev) => !prev)} />
        <Modal.Icon icon={<Siren size={60} color="#BB0000" weight="fill" />} />
        <Modal.Content
          value="Alerta Enviado!"
          subvalue="O alerta foi enviado para todos aqueles funcionários que não estão com ocorrências em andamento. Durante o tempo que você definiu eles terão a chance de responder o aviso."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => setSendedAlert((prev) => !prev)}
          >
            <Button.Content title="Voltar para página" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        width="fit-content"
        height="fit-content"
        left="50%"
        top="50%"
        open={unblockUser}
        setIsOpenController={() => setUnblockUser(false)}
      >
        <Modal.Header onclick={() => setUnblockUser(false)} />
        <Modal.Content
          value="Você deseja realmente reativar usuário?"
          subvalue="Ao clicar em SIM, os acessos do usuário voltarão a normalidade"
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#fff"
            border="1px solid #770A00"
            onClick={() => setUnblockUser(false)}
          >
            <Button.Content title="Não" color="#770A00" />
          </Button.Root>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => {
              setUnblockUser(false)
              setUnblockUserConfirm(true)
              handleUnblockUser()
            }}
          >
            <Button.Content title="Sim" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        height="fit-content"
        width="25%"
        left="50%"
        top="50%"
        open={unblockUserConfirm}
        setIsOpenController={() => {
          setUnblockUserConfirm(false)
          location.reload()
        }}
      >
        <Modal.Header onclick={() => setUnblockUserConfirm(false)} />
        <Modal.Icon icon={<Siren size={60} color="#BB0000" weight="fill" />} />
        <Modal.Content
          value="Usuário desbloquado"
          subvalue="Os acessos do usuário voltarão a normalidade a partir desse momento, o sistema está atualizando."
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#00517D"
            onClick={() => location.reload()}
          >
            <Button.Content title="Voltar para página" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>

      <Modal.Root
        backgroundcolor="#fff"
        borderradius="6px"
        height="fit-content"
        width="25%"
        left="50%"
        top="50%"
        open={unansweredMessagesModal}
        setIsOpenController={() => setUnansweredMessagesModal(false)}
      >
        <Modal.Header onclick={() => setUnansweredMessagesModal(false)} />
        <Modal.Icon icon={<Siren size={60} color="#BB0000" weight="fill" />} />
        <Modal.Content
          value="Funcionário não respondeu alerta"
          subvalue={`${unansweredMessages.length} funcionários não responderam o sempre alerta, acesse a sessão de avisos dentro do Sempre Alerta e verifique em detalhes`}
        />
        <Modal.Footer>
          <Button.Root
            backgroundColor="#770A00"
            onClick={() => {
              // navigate('/vigilancia/sempre-alerta')
              setUnansweredMessagesModal(false)
            }}
          >
            <Button.Content title="Ir para sempre alerta" color="#fff" />
          </Button.Root>
        </Modal.Footer>
      </Modal.Root>
    </>
  )
}
